<template>
  <q-dialog v-model="opened" ref="modalRef" @hide="loading = false">
    <q-card class="bg-grey-2" id="importModal">
      <q-toolbar class="full-width justify-between text-white bg-primary">
        <div class="q-toolbar-title text-h6">
          {{$t('student.import_student.importmodal')}}
        </div>
        <q-btn class="pull-right" flat @click="opened = false">
          <q-icon name="close"/>
        </q-btn>
      </q-toolbar>
      <q-card-section class="row xs-gutter">

        <q-card class="import-list-card col bg-white">
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>
              {{$t('student.to_import.importmodal')}}
            </q-toolbar-title>
            <span>
            {{$t('student.selected.importmodal', {count: selectedHighlighted})}}
          </span>
          </q-toolbar>
          <q-card-section>
            <q-input v-model="selectedSearch" placeholder="Zoeken" style="width: 100%" :debounce="300">
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </q-card-section>
          <q-list dense no-border>
            <import-student-row v-for="subject in selectedSubjects" :user="subject" :key="subject.uh"
                                @changedHighlight="highlight"></import-student-row>
          </q-list>
        </q-card>
        <div class="col-auto q-ma-sm">
          <div class="column justify-center gutter-xs" style="height: 100%">

            <div class="col-auto">
              <q-btn round color="white" text-color="faded" icon="keyboard_arrow_left" @click="select"></q-btn>
            </div>
            <div class="col-auto">
              <q-btn round color="white" text-color="faded" inverted icon="keyboard_arrow_right"
                     @click="deselect"></q-btn>
            </div>
          </div>
        </div>
        <q-card class="import-list-card col bg-white">
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>
              {{$t('student.available_students.importmodal')}}
            </q-toolbar-title>
            <div>
              {{$t('student.selected.importmodal', {count: availableHighlighted})}}
            </div>
          </q-toolbar>
          <q-card-section>
            <q-input v-model="search" placeholder="Zoeken" style="width: 100%" :debounce="300">
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </q-card-section>

          <q-list dense no-border>
            <import-student-row v-for="subject in importSubjects" :user="subject" :key="subject.uh"
                                @changedHighlight="highlight"></import-student-row>
          </q-list>
        </q-card>
      </q-card-section>
      <q-card-actions align="right">
        <div class="col">
        </div>
        <div class="col-auto">
          <q-btn flat color="black" @click="opened = false">{{$t('student.back.importmodal')}}</q-btn>
        </div>
        <div class="col-auto">
          <q-btn color="primary" class="col-auto" :loading="loading" @click="submit">
            {{$t('student.import.importmodal')}}
          </q-btn>
        </div>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
  import Fuse from 'fuse.js'
  import {
    QBtn,
    QCard,
    QCardActions,
    QCardSection,
    QDialog,
    QList,
    QToolbar,
    QToolbarTitle
  } from 'quasar'
  import ImportStudentRow from '@/components/students/ImportStudentRow'

  const fuzzyOptions = {
    keys: ['firstname', 'middlename', 'lastname', 'email'],
    tokenize: true,
    threshold: 0.2
  }

  export default {
    components: {
      ImportStudentRow,
      QToolbarTitle,
      QCard,
      QList,
      QToolbar,
      QBtn,
      QCardSection,
      QDialog,
      QCardActions
    },
    props: {
      users: Array
    },
    methods: {
      submit () {
        this.$emit('selected', this.selectedSubjects.map(u => ({
          uh: u.uh,
          username: u.username
        })))
        this.loading = true
      },
      hide () {
        this.loading = false
        this.opened = false
      },
      show () {
        this.$refs.modalRef.show()
        this.highlighted = []
        this.selectedUsers = []
      },
      highlight ({ user, bool }) {
        user.highlighted = bool
        if (bool) {
          this.highlighted.push(user.uh)
        } else {
          this.highlighted.splice(this.highlighted.indexOf(user.uh), 1)
        }
      },
      select () {
        this.importSubjects.filter(u => u.highlighted).forEach(u => {
          this.selectedUsers.push(u.uh)
          this.highlighted.splice(this.highlighted.indexOf(u.uh), 1)
        })
      },
      deselect () {
        this.selectedSubjects.filter(u => u.highlighted)
          .forEach(u => {
          this.selectedUsers.splice(this.selectedUsers.indexOf(u.uh), 1)
          this.highlighted.splice(this.highlighted.indexOf(u.uh), 1)
        })
      }
    },
    computed: {
      parsedUsers () {
        return this.users.map(u => {
          u.selected = false
          u.highlighted = this.highlighted.indexOf(u.uh) > -1

          return u
        })
      },
      importSubjects () {
        let subjects = this.parsedUsers.filter(s => this.selectedUsers.indexOf(s.uh) === -1)
        const fuse = new Fuse(subjects, fuzzyOptions)

        if (this.search.length > 0) {
          subjects = fuse.search(this.search)
        }

        return subjects
      },
      selectedSubjects () {
        let subjects = this.parsedUsers.filter(s => this.selectedUsers.indexOf(s.uh) > -1)

        const fuse = new Fuse(subjects, fuzzyOptions)

        if (this.selectedSearch.length > 0) {
          subjects = fuse.search(this.selectedSearch)
        }

        return subjects
      },
      selectedHighlighted () {
        return this.selectedSubjects.filter(s => s.highlighted).length
      },
      availableHighlighted () {
        return this.importSubjects.filter(s => s.highlighted).length
      }
    },
    data () {
      return {
        highlighted: [],
        selectedUsers: [],
        search: '',
        selectedSearch: '',
        loading: false,
        opened: false
      }
    }
  }
</script>

<style lang="stylus">
  .import-list-card .q-list {
    max-height 370px
    overflow-y auto
  }

  .modal-footer {
    box-shadow: none;
  }
</style>

<style scoped lang="stylus">
  #importModal {
    min-width: 70vw;
    min-height: 40vh;
  }
</style>
